import FooterNavbar from "./FooterNavbar.js";
export default FooterNavbar;
